import fetch from 'auth/FetchInterceptor'

const AgencyService = {}

AgencyService.fetch = function () {
	return fetch({
		url: '/client-companies',
		method: 'get'
	})
}

AgencyService.create = function (data) {
	return fetch({
		url: '/client-companies',
		method: 'post',
		data
	})
}

AgencyService.update = function (data) {
	return fetch({
		url: '/client-companies/' + data.id,
		method: 'put',
		data
	})
}

AgencyService.delete = function (id) {
	return fetch({
		url: '/client-companies/' + id,
		method: 'delete'
	})
}

export default AgencyService;